class BackendFilters {
	constructor(
		element,
		preFilterCallback = undefined,
		postFilterCallback = undefined,
	) {
		pp.log("BackendFilters init", element);
		this.FILTER_EFFECTS_NO_MATCH_CLASS = {
			isolate: "hidden",
			highlight: "BackendFilters--no-match",
		};
		this.FILTER_RELATION_METHODS = {
			intersect: (filterResults) => {
				return $(_.intersection(...filterResults));
			},
		};
		this.FILTER_MATCH_CLASS = "BackendFilters--match";
		this.EMPTY_SET_HTML = `<div class='alert alert-info BackendFilters--empty-set'>\
			<p>${I18n.t("global.no_matches")}</p>\
			<p><a href='javascript:;' class='button btn-primary j-reset-backend-filters'>${I18n.t("users.reset_button")}</a></p>\
		</div>`;

		const $container = $(element);

		this.$filters = $container.find(
			"select[data-match-attribute], input[data-match-attribute]",
		);
		this.$filterableElementsContainer = $(
			// @ts-expect-error
			$container.attr("data-filter-container-selector"),
		);
		if (!this.$filterableElementsContainer.length) {
			console.error(
				`No container found for selector ${$container.attr("data-filter-container-selector")}`,
			);
		}
		this.filterElementsSelector = $container.attr(
			"data-filter-elements-selector",
		);
		// @ts-expect-error
		this.$filterableElements = this.$filterableElementsContainer.find(
			this.filterElementsSelector,
		);
		this.filterRelation =
			$container.attr("data-filter-relation") || "intersect";
		this.filterEffect = $container.attr("data-filter-effect") || "isolate";

		this.preFilterCallback = preFilterCallback;
		this.postFilterCallback = postFilterCallback;
		this.$finalResults = [];
		this.dataPerFilter = [];

		// @ts-expect-error
		this.observeChange("$finalResults", this.visualUpdate);

		// this.debug = true;

		this.setupListeners();
		this.setupMutationObserver();
	}

	log(...args) {
		// @ts-expect-error
		if (this.debug) {
			console.log(
				"%cBackendFilters::",
				"background: #18864b; color: #fff; padding: 2px;",
				...args,
			);
		}
	}

	// NOTE: Only supports adding html nodes at the moment
	isSkippableMutation(type, target, addedNodes) {
		if (type != "childList" || !addedNodes) {
			return true;
		}

		const whiteListedSelectors = [this.filterElementsSelector];
		const $firstAddedNode = $(addedNodes[0]);

		const pertinentElForFilter = whiteListedSelectors.some(
			// @ts-expect-error
			(whiteListedSelector) => $firstAddedNode.is(whiteListedSelector),
		); // ".is" will cover ids and classes
		this.log(
			"isSkippableMutation",
			$firstAddedNode,
			whiteListedSelectors,
			pertinentElForFilter,
		);
		return !pertinentElForFilter;
	}

	setupMutationObserver() {
		const observer = new MutationObserver((mutations) => {
			mutations.forEach(({ type, target, addedNodes }) => {
				this.log("Mutation", type, target);
				if (!this.isSkippableMutation(type, target, addedNodes)) {
					this.handleMutations();
				}
			});
		});
		// @ts-expect-error
		observer.observe(this.$filterableElementsContainer.get(0), {
			childList: true,
		});
	}

	setupListeners() {
		this.$filters.each((index, filter) => {
			const $filter = $(filter);
			this.dataPerFilter.push({
				results: this.$filterableElements.get(), // Start with a full set for intersection
				matchAttr: $filter.attr("data-match-attribute"),
				matchMethod: $filter.attr("data-match-method"),
			});
			$filter.on("change", (event) =>
				this.handleInputChange($(event.currentTarget), index),
			);
		});
	}

	// E.g. elements are added or removed from the container
	handleMutations() {
		// Add new elements to set
		// @ts-expect-error
		this.$filterableElements = this.$filterableElementsContainer.find(
			this.filterElementsSelector,
		);
		this.log(
			"Handle mutations",
			this.$filterableElements,
			this.filterElementsSelector,
		);
		// "Trigger" input changes
		this.$filters.each((index, filter) =>
			this.handleInputChange($(filter), index),
		);
	}

	handleInputChange($filter, filterIndex) {
		if (this.preFilterCallback) {
			this.preFilterCallback();
		}

		const thisFilterData = this.dataPerFilter[filterIndex];

		thisFilterData.filterValue = $filter.val().toJSVal();
		this.log("Filter Details", thisFilterData);

		thisFilterData.results = this.performFilter(thisFilterData);
		this.log("filterResults:", thisFilterData.results);

		this.updateFinalResults(thisFilterData);
		this.handleCollapsibleContainer();

		if (this.postFilterCallback) {
			this.postFilterCallback();
		}
	}

	updateFinalResults({ filterValue }) {
		const resultsOfAllFilters = this.dataPerFilter.map(
			(filterData) => filterData.results,
		);
		if (resultsOfAllFilters.some((arr) => arr.length > 0)) {
			this.$finalResults =
				this.FILTER_RELATION_METHODS[this.filterRelation](resultsOfAllFilters);
		} else if (filterValue !== null) {
			this.$finalResults = [];
		}
		this.log("finalResults:", this.$finalResults);
	}

	performFilter({ filterValue, matchAttr, matchMethod }) {
		this.log(
			"filterableElements:",
			this.$filterableElements.length,
			", filterValue:",
			filterValue,
			", matchAttr:",
			matchAttr,
			", matchMethod:",
			matchMethod,
		);
		if (filterValue === null) {
			// Must be a reset
			this.log("RETURNING all");
			return this.$filterableElements.get();
		}

		return this.$filterableElements
			.filter((_, element) => {
				let elementValue = $(element).attr(matchAttr);
				if (elementValue === undefined) {
					return false;
				}
				// @ts-expect-error
				elementValue = elementValue.toJSVal();
				this.log("- at", element, elementValue, matchMethod);

				// Test if `elementValue` is present, otherwise running operations on it is not possible
				return (
					elementValue !== undefined && elementValue[matchMethod](filterValue)
				);
			})
			.get();
	}

	resetFilters(event) {
		const thisInstance = event.data;
		thisInstance.$filters.each((_, filter) => {
			switch (filter.nodeName) {
				case "SELECT":
					$(filter).val("").trigger("change");
					break;

				default:
					console.error("Trying to reset an unsupported input.");
					break;
			}
		});
	}

	visualUpdate() {
		this.$filterableElementsContainer
			// @ts-expect-error
			.find(".BackendFilters--empty-set")
			.remove();

		this.$filterableElements.removeClass(this.FILTER_MATCH_CLASS);
		this.$filterableElements.addClass(
			this.FILTER_EFFECTS_NO_MATCH_CLASS[this.filterEffect],
		);

		if (this.$finalResults.length) {
			// No filter applied (or all elements matched)
			if (this.$filterableElements.length == this.$finalResults.length) {
				this.$filterableElements.removeClass(
					this.FILTER_EFFECTS_NO_MATCH_CLASS[this.filterEffect],
				); // Remove for all
			} else {
				// @ts-expect-error
				this.$finalResults.removeClass(
					this.FILTER_EFFECTS_NO_MATCH_CLASS[this.filterEffect],
				); // Remove for matched elems
				// @ts-expect-error
				this.$finalResults.addClass(this.FILTER_MATCH_CLASS);
			}
		} else if (this.filterEffect == "isolate") {
			const $emptySetHtml = $(this.EMPTY_SET_HTML);
			// @ts-expect-error
			this.$filterableElementsContainer.prepend($emptySetHtml);
			$emptySetHtml
				.find(".j-reset-backend-filters")
				.one("click", this, this.resetFilters);
		}
	}

	handleCollapsibleContainer() {
		const $parentModule = this.$filters.first().parents(".Module");
		const $showMoreButton = $parentModule.find(".j-show-more");
		const $toggleButton = $parentModule.find(".j-show-toggle");
		if (!$showMoreButton.length) {
			return;
		}
		const resetSizeClicks = $showMoreButton.hasClass("hidden") ? 2 : 3;
		for (let i = 0; i < resetSizeClicks; i++) {
			$toggleButton.click();
		}
	}
}

export function initBackendFilters(
	$container = $("body"),
	preFilterCallback,
	postFilterCallback,
) {
	const $filterGroups = $container.find(".FilterGroup");
	$filterGroups.each((index, filterGroup) => {
		if ($(filterGroup).data("backendFilter") === undefined) {
			$(filterGroup).data(
				"backendFilter",
				new BackendFilters(filterGroup, preFilterCallback, postFilterCallback),
			);
		}
	});
}
